import React, { Fragment, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ShowToast } from '../../../common/Toastr';
import fetchAPI from '../../../common/fetchAPI';
import { useTranslation } from 'react-i18next';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as yup from 'yup';
import { logOut } from '../../../common/auth/Auth'
import '../../../common/css/timeLive.css'
import { getValueFromResource } from '../../../common/timeLiveFunction';
const {   REACT_APP_TIMELIVE_ACCESS_TOKEN } = process.env



export const AccountDisableForm = () => {
    const initialValues = {
        UserName: '',
        Password: ''
    };
    const [isLoading, setIsLoading] = useState(false);
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const { t } = useTranslation();
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    useLayoutEffect(() => {

        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }  if (defaultFocusRef.current) {
                defaultFocusRef.current.focus();
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);


    useEffect(() => {

    },
     [])

    const handleSubmit = async (values: any) => {
        
        setIsLoading(true);
        const response = await fetchAPI(`api/V2/Account/DisableAccount`, 'PUT',{UserName:values.UserName,Password:values.Password,AccessToken:REACT_APP_TIMELIVE_ACCESS_TOKEN as string}, true);
        const json = await response.json();
        if (json) {
            logOut();
            ShowToast("Thanks for using TimeLive. Your account has been disabled successfully.", 'Success', "success", "toast-top-right")
            setIsLoading(false);
        }
        else {
            setIsLoading(false);
        }
    };


    return (
        <>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    UserName: yup
                        .string()
                        .label
                        // (t('UserName'))
                        (getValueFromResource('UserName',dispatch, t))

                        .trim()
                        .required
                        // (t('UserName field is required')),
                        (getValueFromResource('UserName field is required',dispatch, t)),

                    Password: yup
                        .string()
                        .label
                        // (t('Password'))
                        (getValueFromResource('Password',dispatch, t))

                        .trim()
                        .required
                        // (t('Password field is required'))
                        (getValueFromResource('Password field is required',dispatch, t))

                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <div className="card card-custom">
                            <div className="card-header  sticky-top bg-white">
                                <h3 className="card-title fw-bold headerTitle"  >
                                    {/* {t('Disable Account')} */}
                                    {getValueFromResource('Disable Account',dispatch, t)}

                                    </h3>
                            </div>
                            <div className="card-body flow" style={{padding:'1rem 0rem'}}>
                                <div className='row'>
                                    <div className="col-md-6 ">
                                        <div className="alert alert-warning" >
                                            <label className="control-label">
                                                {/* {t('Disabling account will stop any activities in your TimeLive account. Your employee will not be able to login in TimeLive.')} */}
                                                {getValueFromResource('Disabling account will stop any activities in your TimeLive account. Your employee will not be able to login in TimeLive.',dispatch, t)}

                                             </label>
                                        </div>
                                    </div>
                                </div>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="row">
                                            <div className='col-md-6'>
                                                <label className="fs-7 fs-7 fw-normal mb-3">
                                                    {/* {t('Administrator Username')} */}
                                                    {getValueFromResource('Administrator Username',dispatch, t)}

                                                    </label>
                                                <input
                                                    type="text"
                                                    className="form-control fs-7 fw-normal"
                                                    id='UserName'
                                                    name='UserName'
                                                    value={values.UserName}
                                                    onChange={handleChange('UserName')}
                                                    ref={defaultFocusRef}
                                                    // onBlur={() => setFieldTouched('UserName')}
                                                />
                                                <div style={{ paddingRight: 20 }}>
                                                    {touched.UserName && errors.UserName &&
                                                        <p className='errorMsg'>{errors.UserName as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <label className="fs-7 fs-7 fw-normal mb-3">
                                                    {/* {t('Administrator Password')} */}
                                                    {getValueFromResource('Administrator Password',dispatch, t)}

                                                    </label>
                                                <input
                                                    type="password"
                                                    className="form-control fs-7 fw-normal"
                                                    id='Password'
                                                    name='Password'
                                                    value={values.Password}
                                                    onChange={handleChange('Password')}
                                                    // onBlur={() => setFieldTouched('Password')}
                                                    autoComplete="new-password"
                                                />
                                                <div style={{ paddingRight: 20 }}>
                                                    {touched.Password && errors.Password &&
                                                        <p className='errorMsg'>{errors.Password as string}</p>
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    </>
                                }
                            </div>
                            <div className='card-footer pt-4 '>
                                <div className='d-flex flex-stack '>
                                    
                                    <button type="button"
                                    style={{marginLeft:'-30px'}}
                                        className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm"
                                        onClick={() => handleSubmit()}
                                        disabled={!isValid}
                                    >
                                         {/* {t('Save')}   */}
                                         {getValueFromResource('Save',dispatch, t)}

                                    </button>
                                      
                                </div>
                            </div>

                        </div>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}


